import { useSelector } from 'react-redux';
import type { Content } from '@plone/types';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import type { BlockWrapperDataProps } from '../BlockWrapper/BlockWrapper';
import View from './View';
import { IntlShape } from 'react-intl';

interface EditProps {
  data: BlockWrapperDataProps;
  content: Content;
  block: string;
  onChangeBlock: (blockId: string, newData: any) => void;
  selected: boolean;
  intl: IntlShape;
  blocksConfig: any;
}

const Edit = (props: EditProps) => {
  const { data, onChangeBlock, block, selected, blocksConfig, content } = props;
  const formData = useSelector(
    (state: { form: { global: Content } }) => state.form.global,
  );
  return (
    <>
      <View
        isEdit
        block={block}
        onChangeBlock={onChangeBlock}
        data={data}
        content={formData || content}
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          onChangeField={(id: any, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
